import bookingServiceReducer from 'features/Booking/services/reducer';
import uiServiceReducer from 'services/UI/reducer';

const rootReducer = {
  ui: uiServiceReducer,
  booking: bookingServiceReducer,
};

export default rootReducer;
